module.exports = __webpack_public_path__ + "static/media/right-arrow.4f39489a.svg";